module.exports = __webpack_public_path__ + "static/media/windmill.3bdde763.JPG";